interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const baseSchemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '90影视',
      url: 'https://www.90yingshi.com',
      description: '90影视免费在线观看平台，电影电视剧综艺动漫全集不缓冲无广告，高清画质流畅播放。',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'contact@90yingshi.com',
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '90影视',
      url: 'https://www.90yingshi.com',
      description: '免费在线观看不缓冲全集高清无广告影视平台',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: 'https://www.90yingshi.com/search?q={search_term_string}',
        },
        'query-input': 'required name=search_term_string',
      },
      inLanguage: 'zh-CN',
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: data?.name || '90影视',
      description: data?.description || '90影视免费在线观看平台',
      url: data?.url || 'https://www.90yingshi.com',
      inLanguage: 'zh-CN',
      isPartOf: {
        '@type': 'WebSite',
        name: '90影视',
        url: 'https://www.90yingshi.com',
      },
      ...(data?.breadcrumb && { breadcrumb: data.breadcrumb }),
    },
    BreadcrumbList: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: data?.items || [],
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: data?.headline || '',
      description: data?.description || '',
      datePublished: data?.datePublished || '',
      author: {
        '@type': 'Organization',
        name: '90影视',
      },
      publisher: {
        '@type': 'Organization',
        name: '90影视',
      },
      inLanguage: 'zh-CN',
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: data?.questions || [],
    },
  };

  const schema = baseSchemas[type];

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}